import React, { useState } from "react";
import Clientes from "./pages/Clientes";

import Header from "../../components/Header";
import Container from "../../componentsv2/Container";

export default function AgendaCare() {
  const [aba, setAba] = useState(0);

  return (
    <>
    <Header titulo="Gestão de Clientes"/>
    <Container>
      <div style={{ paddingBottom: "0" }} id="container-aba-ctrl">
        <button
          id={aba === 0 ? "button-aba-ctrl-samples-selected" : "aba0"}
          type="button"
          className="button-aba-ctrl"
          style={{ fontSize: "16px" }}
          onClick={() => {
            setAba(0);
          }}
        >
          Clientes
        </button>
      </div>
      {aba === 0 && <Clientes />}
      </Container>
      </>
  );
}
